export default __webpack_public_path__ + "static/media/photo--sm--misc-20.ac1d74f4.jpg";